import { useState } from "react";
import { toast } from "sonner";
import { Copy, Gift, Loader2 } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { createOffer } from "@/lib/api";
import { waLink } from "@/lib/wa";
import Field from "./Field";

export default function OfferMaker({ url, packages }) {
  const [salon, setSalon] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(null);
  const [made, setMade] = useState(null);
  const make = (pk) => {
    if (!salon.trim()) return toast.error("Scrie numele salonului");
    setBusy(pk.id);
    createOffer({ pack_id: pk.id, salon: salon.trim(), phone: phone.trim() })
      .then((o) => setMade({ ...o, pack: pk, link: `${url}?o=${o.id}&oferta=${pk.id}#profit` }))
      .catch(() => toast.error("Nu am putut crea oferta"))
      .finally(() => setBusy(null));
  };
  const msg = made && `Bună ziua! V-am pregătit oferta ${made.pack.name} (-${made.pack.discount}%) pentru ${made.salon}, cu calculul de profit gata făcut: ${made.link}`;
  const wa = made && (waLink(made.phone, msg) || `https://wa.me/?text=${encodeURIComponent(msg)}`);
  const reset = () => { setMade(null); setSalon(""); setPhone(""); };
  return (
    <div className="share-offers" data-testid="share-offers">
      <div className="st-section-title"><Gift size={12} /> Ofertă pentru un salon</div>
      {made ? (
        <div className="offer-made" data-testid="offer-made">
          <p className="st-hint">Ofertă <b>{made.pack.name}</b> pentru <b>{made.salon}</b> gata:</p>
          <code data-testid="offer-made-link">{made.link}</code>
          <div className="share-actions">
            <a className="st-btn st-btn--light" href={wa} target="_blank" rel="noopener noreferrer" data-testid="offer-made-whatsapp-btn"><WhatsAppGlyph /> Trimite pe WhatsApp</a>
            <button type="button" className="st-btn st-btn--ghost" onClick={() => navigator.clipboard.writeText(made.link).then(() => toast.success("Link copiat"))} data-testid="offer-made-copy-btn"><Copy size={14} /> Copiază</button>
            <button type="button" className="st-btn st-btn--ghost" onClick={reset} data-testid="offer-new-btn">Ofertă nouă</button>
          </div>
        </div>
      ) : (
        <>
          <Field label="Nume salon" value={salon} onChange={setSalon} testId="offer-salon-input" />
          <Field label="Telefon salon (opțional)" value={phone} onChange={setPhone} testId="offer-phone-input" />
          <div className="share-actions">
            {packages.map((pk) => (
              <button key={pk.id} type="button" className="st-btn st-btn--ghost" disabled={!!busy} onClick={() => make(pk)} data-testid={`share-offer-${pk.id}`}>
                {busy === pk.id ? <Loader2 size={14} className="animate-spin" /> : <Gift size={14} />} {pk.name.replace("Pachet ", "")}
              </button>
            ))}
          </div>
          <p className="st-hint">Salonul vede „Ofertă pentru {salon.trim() || "Salon X"}” și calculatorul deja completat.</p>
        </>
      )}
    </div>
  );
}
